import React from 'react'
import '../assets/css/components/storyline-table-row.css'
//const StorylineTableRow = ({questName, assignmentCount}) => {
class StorylineTableRow extends React.Component {

  render() {
    const {quest, assignmentCount, handleQuestClick} = this.props
    quest.type = 'quests' //temporary matching for the assignment popup
    return(
      <div className='storyline-table-row'>
        {assignmentCount > 0 ?
          <p className='quest-title'>{quest.name}</p> : <a className='quest-title-link' onClick={()=>handleQuestClick(quest)}>{quest.name}</a>
        }
        <p className='assignment-count'>{assignmentCount > 0 ? assignmentCount + ' INDIVIDUALS' : 'NOT ASSIGNED'}</p>
      </div>
    )
  }
}

export default StorylineTableRow
